import { GraphicAreaBody } from './GraphicAreaBody'
import { GraphicAreaFooter } from './GraphicAreaFooter'
import { GraphicAreaHeader } from './GraphicAreaHeader'
import { GraphicAreaRoot } from './GraphicAreaRoot'

export const GraphicArea = {
  Root: GraphicAreaRoot,
  Header: GraphicAreaHeader,
  Body: GraphicAreaBody,
  Footer: GraphicAreaFooter,
}
